<script setup>
import OfLeadsList from '@dk.onlinefundraising/onboarding-utils/src/components/lead/OfLeadsList.vue'
import { currentPage, entities, extractQueryParams, reloader } from '@dk.onlinefundraising/onboarding-utils/src/pageHandler';
import OfCampaignsList from '@dk.onlinefundraising/onboarding-utils/src/components/campaign/OfCampaignsList.vue';
import OfSessionsList from '@dk.onlinefundraising/onboarding-utils/src/components/session/OfSessionsList.vue';
import OfWorkflowsList from '@dk.onlinefundraising/onboarding-utils/src/components/workflow/OfWorkflowsList.vue';
import OfWorkflowModal from '@dk.onlinefundraising/onboarding-utils/src/components/workflow/OfWorkflowModal.vue';
import OfAgenciesList from '@dk.onlinefundraising/onboarding-utils/src/components/agency/OfAgenciesList.vue';
import OfLeadModal from '@dk.onlinefundraising/onboarding-utils/src/components/lead/OfLeadModal.vue';
import OfCampaignModal from '@dk.onlinefundraising/onboarding-utils/src/components/campaign/OfCampaignModal.vue';
import OfSessionModal from '@dk.onlinefundraising/onboarding-utils/src/components/session/OfSessionModal.vue';
import { merchant } from '@/store';
import { onMounted } from 'vue';
import { userAllowed } from '@/functions';

onMounted(() => {
  extractQueryParams();
})
</script>
<template>

  <h1>Merchant: {{ merchant.name }}</h1>

  <OfLeadsList v-if="currentPage == 'leads' && userAllowed('READ_LEAD')" :key="reloader" />

  <OfCampaignsList v-if="currentPage == 'campaigns' && userAllowed('READ_WORKFLOW')" :key="reloader" />

  <OfSessionsList v-if="currentPage == 'sessions' && userAllowed('READ_SESSION')" :key="reloader" />

  <OfWorkflowsList v-if="currentPage == 'workflows' && userAllowed('READ_WORKFLOW')" :key="reloader" />

  <OfAgenciesList v-if="currentPage == 'agencies'" :key="reloader" />

  <OfLeadModal v-if="entities.lead.entity" :lead="entities.lead.entity" />

  <OfCampaignModal v-if="entities.campaign.entity" />

  <OfWorkflowModal v-if="entities.workflow.entity" />

  <OfSessionModal v-if="entities.session.entity" :session="entities.session.entity" />

</template>
